<script setup lang="ts">
definePageMeta({
  layout: 'search',
})

useSetSEO()
useScrollRestoration()
</script>

<template>
  <NovaSearchResultDetailComment />
</template>

<style scoped lang="scss"></style>
